const actions = {
  setInit(context) {
    context.commit('SET_INIT');
  },
};

export default actions;
